import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { useAtom } from 'jotai'
import {
  genTidalAtom,
  optionsAtom,
  paintTimesAtom,
  paintTimesStepAtom,
} from './atom'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import Stepper from '../Stepper'
import { useAuth } from '~/hooks/useAuth'
import { useType } from '../useType'

export const PaintTimesComp = observer(() => {
  const [options] = useAtom(optionsAtom)
  const [paintTimes, setPaintTimes] = useAtom(paintTimesAtom)
  const [genTidal] = useAtom(genTidalAtom)
  const [paintTimesStep] = useAtom(paintTimesStepAtom)
  const { isBigMJ, isMJ } = useType()

  const { isHighUser } = useAuth()

  // 会员用户使用潮汐模式一次作画最多20张
  const max = Math.min(
    options?.numCeiling || 100,
    isHighUser && genTidal ? 20 : Infinity
  )

  useEffect(() => {
    if (genTidal && isHighUser) {
      setPaintTimes(Math.min(20, paintTimes))
    }
  }, [genTidal, isHighUser])

  return (
    <div className="flex items-center justify-between mb-4">
      <span className="text-neutral-500">
        作图数量{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title={
            isBigMJ
              ? 'MJ模型默认一次作图数量为4张'
              : '"每增加1张作图数量将成倍增加消耗的总积分"'
          }
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <Stepper
        disabled={isMJ}
        step={paintTimesStep}
        min={paintTimesStep}
        max={max}
        value={paintTimes}
        onChange={val => {
          setPaintTimes(Math.floor(val / paintTimesStep) * paintTimesStep)
        }}
      />
    </div>
  )
})
